/** Tiny className joiner (avoids pulling in clsx). */
export function cn(...parts) {
  return parts.filter(Boolean).join(' ');
}
